import { toAppPathname } from "./PublicUrl";
import { PandoraMode } from "./ConfigurationService";

export const appMode = process.env.REACT_APP_PANDORA_MODE === 'light' ? 'light' : 'full';

const envMode = process.env.REACT_APP_PANDORA_MODE;

let currentMode: PandoraMode =
  envMode === "light" || envMode === "full" ? envMode : "full";

export const setPandoraMode = (mode: PandoraMode) => {
  currentMode = mode;
};

export const getPandoraMode = (): PandoraMode => currentMode;

export const isLightMode = (): boolean => currentMode === "light";

export const LIGHT_MODE = [
  '/Home',
  '/',
  '/Pandora/Home',
  '/ValidationReports',
  '/ValidationReport',
  '/ValidatorHome',
  '/AuditEventExchanges',
  '/AuditEventExchangeDetails',
  '/Error',
  '/InProgress',
];

export const isRouteAllowedInLightMode = (pathname: string): boolean => {
  const appPathname = toAppPathname(pathname);

  return LIGHT_MODE.some(prefix => {
        if (prefix === '/') {
            return appPathname === '/';
        }
        return appPathname === prefix || appPathname.startsWith(`${prefix}/`);
    });
};
